import SubcontractorDeleteForm from "./subcontractor-delete-form";

export default SubcontractorDeleteForm;